/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Next_3Inputs */

const en_contact_next_3 = /** @type {(inputs: Contact_Next_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If there is a useful fit, we suggest a 30-minute call.`)
};

const lv_contact_next_3 = /** @type {(inputs: Contact_Next_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja redzam, kā varētu palīdzēt, piedāvājam 30 minūšu sarunu.`)
};

/**
* | output |
* | --- |
* | "If there is a useful fit, we suggest a 30-minute call." |
*
* @param {Contact_Next_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_next_3 = /** @type {((inputs?: Contact_Next_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Next_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_next_3(inputs)
	return en_contact_next_3(inputs)
});